{
  "branding": {
    "frontdesk-attribution": "Omogućuje FrontDesk+",
    "practice-logo": "Logotip ordinacije {{name}}"
  },
  "validation": {
    "required": "Ovo polje je obavezno",
    "invalid-url": "Molimo unesite važeći URL",
    "pin-too-short": "PIN mora imati najmanje 4 znaka",
    "pin-default-rejected": "Standardni PIN 0000 nije dopušten. Dodijelite vlastiti PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Natrag",
    "next": "Sljedeće",
    "cancel": "Otkaži",
    "confirm": "Potvrdi",
    "done": "Gotovo",
    "retry": "Pokušaj ponovno",
    "clear": "Obriši",
    "close": "Zatvori",
    "verifying": "Provjera...",
    "select": "Odaberi",
    "minutes": "minuta",
    "clock": "",
    "gender": {
      "M": "Muški",
      "W": "Ženski",
      "D": "Raznovrstan",
      "U": "Nepoznato"
    },
    "insurance": {
      "GKV": "Zakonsko",
      "PKV": "Privatno",
      "SELFPAY": "Samoplačanje"
    },
    "scroll-up": "Pomakni prema gore",
    "scroll-down": "Pomakni prema dolje"
  },
  "settings": {
    "device-reset": {
      "title": "Ponovno postavi uređaj",
      "description": "Izbriši vezu s ordinacijom, postavke i PIN ovog uređaja.",
      "confirmation": "Ovaj uređaj trebat će ponovno postaviti. Konfiguracija SOL-a i podaci pacijenata u inSuiteu ostaju nepromijenjeni.",
      "cancel": "Odustani",
      "confirm": "Ponovno postavi"
    },
    "title": "Postavke",
    "save": "Spremi",
    "save-success": "Postavke spremljene",
    "save-error": "Neuspješno spremanje postavki",
    "load-error": "Neuspješno učitavanje postavki",
    "pin": {
      "title": "Potreban PIN",
      "description": "Molimo unesite svoj PIN za pristup postavkama.",
      "error": "Pogrešan PIN. Molimo pokušajte ponovno.",
      "backspace": "Izbriši posljednju znamenku"
    },
    "connection": {
      "title": "Veza",
      "description": "Postavke veze za Doc-Cirrus Bridge poslužitelj",
      "bridge-url": "Bridge URL",
      "device-name": "Naziv uređaja",
      "device-name-placeholder": "npr. Recepcija, soba 1, kiosk",
      "device-name-hint": "Ime za identifikaciju na nadzornoj ploči Bridge",
      "kim-address": "KIM adresa (nije obavezno)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Veza uspješna",
      "error": "Veza neuspješna",
      "api-unreachable": "DocCirrus API nedostupan",
      "status-title": "Status veze",
      "status": {
        "api": "API povezan",
        "ti": "Telematička infrastruktura",
        "card-reader": "Dostupan čitač kartica",
        "medical-card": "Kartica ordinacije (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol token (iz inSuitea)",
      "sol-token-hint": "Kopirajte ga iz upravljanja Bridgeom u inSuiteu. Potreban je za vezu.",
      "sol-token-show": "Prikaži token",
      "sol-token-hide": "Sakrij token",
      "bridge-unreachable": "Bridge nije dostupan. Provjerite adresu i priključak.",
      "diagnostic-id": "ID dijagnostike: {{id}}",
      "scan-qr": "Skeniraj QR kod",
      "scan-title": "Skeniraj QR kod Bridgea",
      "scan-manual": "Unesi ručno"
    },
    "terminal": {
      "title": "Čitač kartica",
      "description": "Odabir čitača kartica za telematičku infrastrukturu",
      "select": "Odaberi Terminal",
      "select-placeholder": "Odaberi terminal...",
      "loading": "Učitavanje terminala...",
      "none-available": "Nema dostupnih terminala",
      "none-found": "Nema pronađenih terminala",
      "found": "Pronađeno {{count}} terminal(a)",
      "connect-hint": "Prvo se povežite s bridge poslužiteljem za učitavanje terminala.",
      "found-count": "Pronađeni čitači kartica: {{count}}",
      "refresh": "Ponovno učitaj čitače kartica"
    },
    "practice": {
      "title": "Ordinacija",
      "description": "Informacije o vašoj ordinaciji",
      "name": "Naziv ordinacije",
      "name-placeholder": "npr. Dr. Ivan Horvat",
      "welcome-message": "Poruka dobrodošlice",
      "welcome-placeholder": "npr. Dobro došli u našu ordinaciju",
      "scheduler-available": "Omogući planer",
      "scheduler-available-description": "Omogućite pacijentima da rezerviraju termine putem samoposlužnog terminala",
      "prescription-available": "Omogući uslugu izdavanja recepta",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Ostavite prazno kako bi pozdrav bio na jeziku pacijenta. Vaš vlastiti tekst prikazuje se nepromijenjen na svim jezicima."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Spremljeno za sve uređaje {{value}}",
      "never-saved-default": "Zadana postavka, još nije promijenjena."
    },
    "anamnesis": {
      "title": "Digitalna medicinska povijest",
      "description": "Pokazuje vezu i QR code do vašeg pružatelja povijesti bolesti nakon prijave.",
      "enabled": "Prikaži poveznicu povijesti bolesti nakon prijave",
      "enabled-description": "Prikazuje vezu i QR code vašem pružatelju medicinske povijesti nakon dovršene prijave, na primjer Nelly.",
      "url": "Veza pružatelja povijesti bolesti",
      "url-hint": "Veza je statična i identična za sve pacijente.",
      "preview-label": "Pregled zaslona završetka",
      "preview-note": "Veza je statična i identična za sve pacijente.",
      "url-first": "Za uključivanje najprije unesite valjanu poveznicu."
    },
    "appearance": {
      "title": "Izgled",
      "description": "Prilagodite korisničko sučelje",
      "language": "Jezik",
      "default-kiosk-language": "Zadani jezik pacijenta",
      "default-kiosk-language-hint": "Jezik na kojem počinju nove sesije na kiosku za pacijente.",
      "voice-over-volume": "Glasnoća zvuka",
      "voice-over-hint": "Upravlja glasnoćom glasovnog asistenta za pristupačnost.",
      "language-first": "Prikaži odabir jezika na početku sesije"
    },
    "security": {
      "title": "Sigurnost",
      "description": "PIN za pristup postavkama",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Upravljanje kioskom",
    "nav": {
      "general": "Općenito",
      "flows": "Funkcije",
      "anamnese": "Digitalna anamneza",
      "device": "Uređaj i veza"
    },
    "flows": {
      "title": "Funkcije na terminalu"
    },
    "language": {
      "title": "Jezik i čitanje naglas",
      "description": "Jezik i čitanje naglas za pacijente na ovom uređaju."
    }
  },
  "self-service": {
    "title": "Samoposluživanje",
    "step-progress": "Korak {{current}} / {{total}}",
    "flows": {
      "checkin": "Prijava",
      "scheduler": "Zakaži termin",
      "prescription": "Recepti",
      "locations": "Karta lokacije",
      "emergency": "Hitnost"
    },
    "audio-guide": {
      "on": "Zvuk uključen",
      "off": "Zvuk isključen",
      "replay": "Ponovi upute",
      "replay-unavailable": "Nema glasovnih uputa za ponavljanje"
    },
    "language-selector": {
      "title": "Odaberite jezik",
      "description": "Molimo odaberite željeni jezik"
    },
    "settings": "Postavke",
    "start": {
      "welcome": "Dobrodošli",
      "subtitle": "Molimo odaberite opciju",
      "check-in-label": "Glavni put",
      "check-in-cta": "Prijava",
      "check-in-description": "Već imate termin? Prijavite se ovdje.",
      "check-in-hint": "Pripremite svoju karticu",
      "scheduler-label": "novo",
      "scheduler-cta": "Zakaži termin",
      "scheduler-description": "Zakažite novi termin.",
      "location-plan": "Karta lokacije",
      "location-plan-description": "Pronađite put do sobe za tretman.",
      "prescription-label": "recept",
      "prescription-cta": "Recepti i naručivanje",
      "prescription-description": "Pogledajte recepte ili naručite dopune.",
      "emergency-cta": "Lokalni alarm za hitne slučajeve",
      "emergency-description": "Čuje se samo na ovom uređaju i ne poziva pomoć.",
      "tap-to-start": "Dodirnite za početak"
    },
    "offline": {
      "banner-title": "Prijava je trenutno nedostupna",
      "banner-message": "Za pomoć se obratite osoblju na recepciji.",
      "emergency-available": "Lokalni alarm ostaje dostupan. Ne poziva pomoć.",
      "flow-disabled": "Privremeno nedostupan"
    },
    "readability": {
      "toggle-label": "Način čitanja",
      "on": "Način čitanja",
      "off": "Način čitanja"
    },
    "reset-overlay": {
      "timeout-title": "Sesija je završila",
      "timeout-subtitle": "Vaše vrijeme je isteklo. Vaši podaci su sigurni.",
      "offline-title": "Veza izgubljena",
      "offline-subtitle": "Veza je bila prekinuta. Molimo razgovarajte s osobljem na recepciji.",
      "interruption-title": "Sesija je završila",
      "interruption-subtitle": "Vaša je sesija sigurno završena.",
      "completion-title": "hvala ti",
      "completion-subtitle": "Vaš zahtjev je uspješno završen.",
      "reassurance": "Vaši osobni podaci nisu pohranjeni na ovom uređaju.",
      "auto-dismiss": "Povratak na početak za {{seconds}} sekundi...",
      "dismiss": "Idi na početak"
    },
    "timed-terminal": {
      "countdown": "Automatski povratak za {{seconds}} sekundi",
      "countdown-outcome": "Ovaj terminal će se automatski vratiti na početni ekran.",
      "more-time": "Više vremena",
      "extended": "Vrijeme produženo"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Ova pitanja nisu dostupna na vašem jeziku. Odaberite jedan od ponuđenih jezika ili se obratite recepciji.",
        "alternatives": "Alternativni termini",
        "loading": "Učitavanje pitanja…",
        "reception-fallback": "Molimo obratite se recepciji.",
        "error-title": "Pitanja nije bilo moguće učitati",
        "language-unavailable-lead": "Ova pitanja nisu dostupna na vašem jeziku.",
        "language-unavailable-title": "Molimo odaberite jedan od ovih jezika",
        "language-unavailable-body": "Ili zatražite pomoć na recepciji."
      },
      "start": {
        "title": "Zakaži termin",
        "subtitle": "Zakažite željeni termin u nekoliko koraka",
        "welcome": "Dobrodošli u zakazivanje termina",
        "description": "Voditi ćemo vas kroz proces zakazivanja",
        "cta": "Zakaži termin sada"
      },
      "patient-id": {
        "title": "Identifikacija",
        "subtitle": "Molimo identificirajte se",
        "mode-card": "S karticom",
        "mode-search": "Pretraži",
        "mode-create": "Stvori novo",
        "insert-card": "Molimo umetnite svoju zdravstvenu karticu",
        "reading-card": "Čitanje kartice...",
        "simulate-card": "Simuliraj karticu",
        "multiple-matches": "Pronađeno više pacijenata. Koriste se podaci s kartice.",
        "search-placeholder": "Ime ili broj osiguranja...",
        "searching": "Pretraživanje...",
        "no-results": "Nema pronađenih rezultata",
        "first-name": "Ime",
        "last-name": "Prezime",
        "dob": "Datum rođenja",
        "insurance": "Osiguranje",
        "continue": "Nastavi",
        "creating": "Stvaranje pacijenta...",
        "patient-created": "Pacijent je uspješno kreiran!",
        "create-error": "Nije moguće stvoriti pacijenta."
      },
      "appointment-type": {
        "title": "Odaberite vrstu termina",
        "subtitle": "Molimo odaberite razlog posjete",
        "loading": "Učitavanje vrsta termina...",
        "no-types": "Nema dostupnih vrsta termina",
        "error": "Nije moguće učitati vrste termina. Molimo pokušajte ponovno.",
        "no-bookable": "Ove vrste termina trenutačno se ne mogu rezervirati na kiosku. Obratite se prijemu ili dogovorite termin telefonom.",
        "disabled-default": "Molimo dogovorite ovaj termin izravno na prijemu ili telefonom.",
        "disabled-footer": "Samo prijem/telefon",
        "lead": "Koju vrstu termina želite rezervirati?",
        "duration": "oko {{minutes}} minuta",
        "empty-title": "Ovdje trenutačno nije moguće rezervirati termine",
        "none-bookable-title": "Ove termine ovdje ne možete rezervirati",
        "none-bookable-body": "Molimo pitajte na recepciji ili nas nazovite."
      },
      "types": {
        "general": "Opći pregled",
        "general-desc": "Za opće tegobe i pitanja",
        "checkup": "Preventivni pregled",
        "checkup-desc": "Redoviti zdravstveni pregledi",
        "vaccination": "Cijepljenje",
        "vaccination-desc": "Zakažite cijepljenje",
        "followup": "Kontrola",
        "followup-desc": "Kontrolni termin",
        "prescription": "Recept",
        "prescription-desc": "Preuzimanje recepta"
      },
      "slot-selection": {
        "title": "Odaberite termin",
        "subtitle": "Molimo odaberite dostupan termin",
        "loading": "Učitavanje dostupnih termina...",
        "no-slots": "Nema dostupnih termina",
        "no-appointment-type": "Nije odabrana vrsta termina",
        "error": "Nije moguće učitati dostupne termine. Molimo pokušajte ponovno.",
        "quick-select": "Sljedeći dostupni termini:",
        "select-date": "Ili odaberite datum:",
        "times-for": "{{date}}",
        "available": "Dostupno",
        "unavailable": "Nema termina",
        "slots": "termini",
        "select-time-hint": "Dodirnite vrijeme za zakazivanje termina",
        "week-short": "Tj",
        "weekday-mon": "Pon",
        "weekday-tue": "Uto",
        "weekday-wed": "Sri",
        "weekday-thu": "Čet",
        "weekday-fri": "Pet",
        "weekday-sat": "Sub",
        "weekday-sun": "Ned",
        "period-morning": "Jutro",
        "period-midday": "Podne",
        "period-afternoon": "Popodne",
        "period-evening": "Večer",
        "period-morning-short": "Jutro",
        "period-midday-short": "Podne",
        "period-afternoon-short": "Pop.",
        "period-evening-short": "Večer",
        "period-dots-legend": "Dostupnost vremena",
        "filter-hint": "Filtriraj po željenim vremenima:",
        "or-choose-below": "ili odaberite ispod",
        "no-slots-period": "Nema utora",
        "show-all": "Prikaži sve",
        "free": "besplatno",
        "your-selection": "Vaš odabir",
        "oclock": "sat",
        "choose-slot": "Odaberite utor",
        "choose-day": "Odaberite dan",
        "choose-day-first": "Molimo najprije odaberite dan",
        "times-heading": "Slobodna vremena {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Nema slobodnih termina: {{month}}",
        "empty-body": "Pogledajte sljedeći mjesec ili pitajte na recepciji – rado ćemo pomoći.",
        "next-month": "Sljedeći mjesec",
        "previous-month": "Prethodni mjesec"
      },
      "confirmation": {
        "patient-responses": "Vaši odgovori",
        "review-loading": "Provjera sažetka…",
        "review-unavailable": "Sažetak nije dostupan. Molimo pokušajte ponovno ili pitajte na recepciji.",
        "check-booking": "Provjeri rezervaciju",
        "title": "Potvrdi termin",
        "subtitle": "Molimo pregledajte svoju rezervaciju",
        "patient": "Pacijent",
        "datetime": "Datum i vrijeme",
        "booking": "Zakazivanje...",
        "confirm": "Zakaži termin",
        "heading": "Izgleda li dobro?",
        "lead": "Molimo potvrdite svoj termin.",
        "appointment": "Imenovanje",
        "insured-via": "Osiguran putem",
        "description-label": "Napomene za ordinaciju (neobavezno)",
        "description-hint": "Javite nam ako nešto trebamo uzeti u obzir pri zakazivanju termina ili prijavi.",
        "description-placeholder": "npr. ograničena pokretljivost, pratnja, važne napomene",
        "description-too-long": "Skratite napomenu na najviše 500 znakova.",
        "summary": "Sažetak",
        "change": "Promjena",
        "book-binding": "Rezervirajte termin",
        "cancel": "Odustani",
        "type-label": "Vrsta termina",
        "datetime-value": "{{date}} u {{time}}",
        "name-label": "Ime",
        "insurance-label": "Osiguranje",
        "insurance-GKV": "Zakonsko zdravstveno osiguranje",
        "insurance-PKV": "Privatno zdravstveno osiguranje",
        "insurance-SELFPAY": "Samoplatitelj",
        "change-time": "Promijeni termin",
        "description-free-text": "Ostale napomene (neobavezno)",
        "note-wheelchair": "Koristim invalidska kolica",
        "note-companion": "Dolazim u pratnji",
        "note-interpreter": "Trebam prevoditelja"
      },
      "done": {
        "title": "Termin zakazan!",
        "label": "Rezervirano",
        "subtitle": "Vaš termin je uspješno zakazan.",
        "date": "Date",
        "time": "Vrijeme",
        "booking-id": "Broj rezervacije",
        "qr-hint": "Dodaj u kalendar",
        "qr-description": "Skenirajte ovaj QR kod kamerom svog pametnog telefona kako biste dodali termin u svoju aplikaciju kalendara",
        "auto-redirect": "Uskoro ćete biti preusmjereni na početnu stranicu...",
        "auto-redirect-countdown": "Povratak na početak za {{seconds}} sekundi...",
        "back-to-start": "Natrag na početak",
        "print-button": "Ispiši potvrdu termina",
        "print-preparing": "Priprema prikaza za ispis…",
        "print-error": "Potvrdu termina nije bilo moguće otvoriti. Pokušajte ponovno ili zatražite pomoć na recepciji.",
        "print-returned": "Sistemski prikaz za ispis je zatvoren. Po potrebi možete zatražiti još jedan primjerak.",
        "print-title": "Vaš termin",
        "print-location": "Lokacija",
        "print-map-hint": "Otvori lokaciju na telefonu",
        "print-error-v2": "Potvrdu termina nije bilo moguće otvoriti. Molimo pokušajte ponovno ili pitajte na recepciji."
      },
      "error": {
        "assistance-info": "Nismo mogli potvrditi vašu rezervaciju. Termin je možda već rezerviran. Molimo pitajte na recepciji.",
        "pending-title": "Rezervacija nije potvrđena",
        "pending-info": "Nismo mogli potvrditi vašu rezervaciju. Termin je možda već rezerviran. Molimo provjerite ponovno ili pitajte na recepciji.",
        "title": "Zakazivanje neuspješno",
        "subtitle": "Termin nije mogao biti zakazan.",
        "info": "Molimo pokušajte ponovno ili pitajte na recepciji."
      },
      "phase": {
        "identify": "Prijava",
        "choose": "Odabir termina",
        "confirm": "Potvrda"
      }
    },
    "prescription": {
      "start": {
        "title": "Recepti i naručivanje",
        "subtitle": "Umetnite svoju karticu osiguranja kako biste vidjeli recepte ili naručili dopune.",
        "button": "Umetnite karticu"
      },
      "card-check": {
        "loading": "Učitavanje čitača kartica...",
        "no-terminal": "Čitač kartica nije konfiguriran",
        "no-terminal-hint": "Obratite se osoblju za pomoć.",
        "insert-card": "Molimo ubacite svoju karticu",
        "insert-card-hint": "Umetnite karticu osiguranja u čitač kartica.",
        "card-detected": "Kartica otkrivena",
        "reading": "Čitanje kartice...",
        "reading-hint": "Molimo pričekajte trenutak.",
        "error": "Pogreška pri čitanju kartice",
        "retry": "Pokušajte ponovno",
        "manual-lookup": "Nastavite bez kartice",
        "load-error": "Nije moguće učitati čitač kartica",
        "read-error": "Kartica se ne može pročitati"
      },
      "patient-selection": {
        "title": "Odaberite pacijenta",
        "subtitle": "Pronađeno je više pacijenata. Odaberite svoje ime.",
        "try-again": "Pokušajte ponovno",
        "try-again-hint": "Ponovno umetnite karticu"
      },
      "list": {
        "title": "Vaši recepti",
        "for-patient": "Recepti za {{name}}",
        "loading": "Učitavanje recepata...",
        "error-title": "Greška pri učitavanju",
        "fetch-error": "Recepti se ne mogu učitati",
        "back-home": "Povratak na početak",
        "done": "Gotovo"
      },
      "detail": {
        "prescription-info": "Informacije o receptu",
        "date": "Date",
        "prescriber": "Propisivač",
        "comment": "Napomena",
        "medications": "Lijekovi",
        "form": "obrazac",
        "pack-size": "Veličina pakiranja",
        "manufacturer": "Proizvođač",
        "loading": "Učitavanje recepta...",
        "fetch-error": "Podaci o receptu nisu se mogli učitati",
        "back-to-list": "Natrag na popis",
        "print": "Ispis"
      },
      "types": {
        "public": "Javni recept",
        "private": "Privatni recept",
        "long-term": "Dugoročni recept",
        "btm": "Recept za narkotike",
        "g": "Zeleni recept",
        "t": "T-recept"
      },
      "no-patient": {
        "title": "Pacijent nije pronađen",
        "subtitle": "Nažalost, za ovu karticu nije pronađen nijedan pacijent. Obratite se osoblju za pomoć.",
        "try-again": "Pokušajte ponovno",
        "back-home": "Povratak na početak",
        "title-v2": "Nema odgovarajućih podataka",
        "subtitle-v2": "Nismo vas mogli pronaći. Molimo pokušajte ponovno ili pitajte na recepciji."
      },
      "done": {
        "title": "Hvala",
        "subtitle": "Sada možete sjesti. Ako imate pitanja, obratite se osoblju.",
        "no-prescriptions-title": "Nema recepta u evidenciji",
        "no-prescriptions-subtitle": "Nismo mogli pronaći nijedan aktivni recept za vas. Ako ga očekujete, obratite se osoblju na recepciji.",
        "error-title": "Došlo je do pogreške",
        "error-subtitle": "Obratite se osoblju za daljnju pomoć.",
        "auto-redirect": "Automatsko preusmjeravanje za {{seconds}} sekundi",
        "finish": "Povratak na početak"
      },
      "hub": {
        "title": "Vaši recepti",
        "for-patient": "Recepti za {{name}}",
        "loading": "Učitavanje recepata...",
        "error-title": "Greška pri učitavanju",
        "fetch-error": "Nije moguće učitati recepte",
        "back-home": "Povratak na početak",
        "done": "Gotovo",
        "order-button": "Naručite recept",
        "existing-prescriptions": "Vaši trenutni recepti",
        "no-prescriptions": "Nema aktivnih recepata."
      },
      "patient-lookup": {
        "title": "Pronađite pacijenta",
        "subtitle": "Unesite svoje ime i datum rođenja.",
        "last-name": "Prezime",
        "first-name": "Ime",
        "date-of-birth": "Datum rođenja",
        "lastname": "Prezime",
        "lastname-placeholder": "Vaše prezime",
        "firstname": "Ime",
        "firstname-placeholder": "Vaše ime",
        "dob": "Datum rođenja",
        "search": "Traži",
        "searching": "Pretraživanje...",
        "search-error": "Pogreška pretraživanja: {{message}}",
        "no-match": "Nijedan pacijent nije pronađen. Provjerite svoje podatke.",
        "error": "Pogreška pretraživanja. Molimo pokušajte ponovo.",
        "found": "Pacijent pronađen",
        "confirm": "Potvrdi",
        "ambiguous": "Više podudaranja",
        "ambiguous-hint-firstname": "Također unesite svoje ime kako biste suzili pretragu.",
        "ambiguous-hint-additional": "Provjerite svoje podatke ili kontaktirajte osoblje.",
        "not-found": "Pacijent nije pronađen",
        "not-found-hint": "Nijedan pacijent nije pronađen s ovim detaljima.",
        "not-found-action": "Pokušajte ponovno"
      },
      "manual-identification": {
        "unverified": "Vaš identitet nije potvrđen zdravstvenom iskaznicom. Ordinacija će provjeriti vaše podatke i zahtjev prije obrade."
      },
      "medication-selection": {
        "title": "Zatražite recept",
        "subtitle": "Ordinacija razmatra vaš zahtjev. Nakon odobrenja, eRx će biti spreman u vašoj aplikaciji e-prescription.",
        "back": "natrag",
        "submit": "Nastavite s pregledom",
        "reason-title": "Zašto vam treba recept?",
        "reason-hint": "Pomaže ordinaciji procijeniti vaš zahtjev.",
        "reason-validation": "Odaberite razlog.",
        "reason-schmerzen": "bol",
        "reason-entzuendung": "upala",
        "reason-nachsorge": "Nakon operacije/zahvata",
        "reason-allergie": "Alergija/reakcija",
        "reason-chronisch": "Kronično stanje",
        "reason-anderes": "Nešto drugo",
        "medications-title": "Koji lijekovi?",
        "request-hint": "Opišite što trebate ili navedite prethodni recept koji želite obnoviti.",
        "request-placeholder": "npr. Ibuprofen 600 mg, isto kao i prošli put",
        "request-validation": "Molimo opišite koji vam je lijek potreban.",
        "history-title": "Prethodni recepti",
        "history-hint": "Dodajte unos kako biste unaprijed ispunili svoj zahtjev.",
        "history-loading": "Učitavanje prethodnih recepata...",
        "history-error": "Prethodni recepti se ne mogu učitati.",
        "history-add": "Dodaj",
        "history-added": "Dodano",
        "history-date": "Posljednji: {{date}}",
        "history-request-line": "Obnovi: {{medicationName}}",
        "urgency-title": "Koliko je hitno?",
        "urgency-hint": "Pomaže ordinaciji odrediti prioritet.",
        "urgency-soon": "Hitno",
        "urgency-soon-meta": "Što prije",
        "urgency-tomorrow": "uskoro",
        "urgency-tomorrow-meta": "U sljedećih nekoliko dana",
        "urgency-week": "Ovaj tjedan",
        "urgency-week-meta": "Bez vremenskog pritiska",
        "lead": "Ordinacija će provjeriti vaš zahtjev. Nakon odobrenja e-recept ćete pronaći u aplikaciji za e-recepte ili na zdravstvenoj iskaznici.",
        "history-hint-v2": "Dodirnite raniji recept kako biste ga preuzeli.",
        "history-retry": "Učitaj ponovno"
      },
      "request-review": {
        "title": "Pregledaj narudžbu",
        "subtitle": "Pregledajte svoj zahtjev za recept.",
        "request-label": "Traženi lijekovi",
        "selected-medications": "Odabrani lijekovi",
        "free-text-medications": "Dodatni lijekovi",
        "freetext-label": "ostalo",
        "quarterly-warning": "Vaša kartica osiguranja nije očitana u ovom tromjesečju. Ordinacija vas može kontaktirati.",
        "egk-warning": "Vaša kartica osiguranja nije očitana u ovom tromjesečju. Ordinacija vas može kontaktirati.",
        "submit": "Pošalji",
        "submitting": "Slanje...",
        "submit-error": "Nije moguće poslati zahtjev. Molimo pokušajte ponovo.",
        "back": "natrag",
        "reason-label": "razum",
        "urgency-label": "Hitnost",
        "completion-email-choice": "Želim primiti e-poruku kada ordinacija obradi moj zahtjev.",
        "completion-email-label": "Adresa e-pošte",
        "completion-email-placeholder": "ime@primjer.hr",
        "completion-email-hint": "Samo za ovu jednokratnu poruku. Adresa se ne sprema u matične podatke.",
        "completion-email-invalid": "Unesite valjanu adresu e-pošte.",
        "egk-proof-required": "Zahtjevi za recept dostupni su samo nakon uspješnog očitanja kartice osiguranja. Obratite se osoblju.",
        "title-v2": "Provjeri zahtjev",
        "completion-email-hint-v2": "Adresa se koristi samo za ovu jednu poruku."
      },
      "confirmation": {
        "title": "Zahtjev poslan",
        "subtitle": "Vaš zahtjev za recept je uspješno predan.",
        "success-title": "Zahtjev poslan",
        "success-subtitle": "Vaš zahtjev za recept je uspješno predan.",
        "estimated-time": "Vaš će recept biti spreman za otprilike {{time}}.",
        "info": "Recept možete podići u ljekarni uz karticu osiguranja ili aplikaciju eRezept.",
        "auto-redirect": "Automatsko preusmjeravanje za {{seconds}} sekundi",
        "back-to-start": "Povratak na početak",
        "handling-label": "Handled by the practice",
        "next-steps": "Ordinacija će provjeriti vaš zahtjev. Nakon odobrenja e-recept možete podići u ljekarni sa zdravstvenom iskaznicom ili aplikacijom za e-recepte."
      },
      "phase": {
        "identify": "Prijava",
        "request": "Zahtjev",
        "review": "Provjera"
      }
    },
    "check-in": {
      "flow-label": "Prijava",
      "has-appointment": {
        "eyebrow": "Imenovanje",
        "title": "Imate li termin?",
        "subtitle": "Molimo odaberite opciju",
        "yes-label": "da",
        "yes": "Da, imam termin",
        "yes-description": "Želim se prijaviti za svoj termin.",
        "yes-hint": "Najbrži put",
        "unsure-label": "možda",
        "unsure": "Nisam siguran",
        "unsure-description": "Provjerit ćemo za vas.",
        "unsure-hint": "Potražit ćemo te",
        "no-label": "br",
        "no": "Ne, bez termina",
        "no-description": "Nemam termin.",
        "no-hint": "Ulazak"
      },
      "card-check": {
        "eyebrow": "Kartica osiguranja",
        "title": "Pročitaj zdravstvenu karticu",
        "subtitle": "Molimo umetnite svoju zdravstvenu karticu u čitač",
        "insert-title": "Umetnite karticu zdravstvenog osiguranja u čitač.",
        "insert-detail": "Automatski čitamo vaše podatke — ne morate učiniti ništa drugo.",
        "other-ways": "Drugi načini",
        "no-card-hint": "Ako trenutno nemate svoju karticu kod sebe.",
        "pkv-hint": "Koristite QR code sa svojom aplikacijom za osiguranje.",
        "loading": "Učitavanje postavki...",
        "no-terminal": "Nema konfiguriranog čitača kartica. Molimo kontaktirajte osoblje.",
        "checking": "Provjera kartica...",
        "insert-prompt": "Molimo umetnite karticu...",
        "card-detected": "Kartica otkrivena! Spremna za čitanje.",
        "read-card": "Pročitaj karticu",
        "simulate-insert": "Simuliraj karticu",
        "reading": "Čitanje kartice...",
        "error": "Nije moguće pročitati karticu. Molimo pokušajte ponovno.",
        "read-error": "Neuspješno čitanje podataka s kartice. Molimo pokušajte ponovno.",
        "settings-error": "Nije moguće učitati postavke. Molimo pokušajte ponovno.",
        "no-card-prompt": "Nemate karticu?",
        "no-card-action": "Ručno pretraživanje",
        "connection-warning": "Problemi s vezom s čitačem kartica. Molimo pričekajte...",
        "pkv-prompt": "Privatno osiguranje? Online Check-in",
        "pkv-instruction": "Skenirajte ovaj QR code pomoću svoje aplikacije za privatno zdravstveno osiguranje kako biste svoje podatke prenijeli digitalno.",
        "pkv-continue": "Nastavite na ručnu registraciju",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Pokušajte ponovno ili se prijavite bez kartice. Recepcija će vam rado pomoći.",
        "title-pkv": "Prijava putem aplikacije",
        "title-reading": "Vaša kartica se očitava …",
        "title-unreadable": "Karticu nije bilo moguće očitati",
        "title-no-terminal": "Prijava bez kartice",
        "no-terminal-body": "Čitač kartica trenutačno nije dostupan. Prijavite se bez kartice ili se obratite recepciji.",
        "reading-detail": "Ostavite karticu u čitaču. Traje samo trenutak.",
        "other-ways-title": "Druge mogućnosti",
        "no-card-title": "Prijava bez kartice",
        "pkv-prompt-title": "Privatno osigurani?",
        "pkv-prompt-hint": "Prijava putem aplikacije vašeg privatnog zdravstvenog osiguranja",
        "pkv-close": "Ipak s karticom",
        "pkv-instruction-app": "Otvorite aplikaciju svog privatnog zdravstvenog osiguranja i skenirajte ovaj kod. Vaši podaci tada stižu izravno k nama."
      },
      "patient-selection": {
        "title": "Odaberite pacijenta",
        "subtitle": "Pronađeno više pacijenata. Molimo odaberite sebe.",
        "firstname-label": "Vaše ime",
        "firstname-placeholder": "Unesite ime...",
        "confirm-button": "Potvrdi",
        "no-match": "Nije pronađen odgovarajući pacijent. Molimo otiđite na recepciju za pomoć.",
        "still-ambiguous": "Ostalo je više utakmica. Molimo otiđite na recepciju za pomoć.",
        "select-error": "Identifikacija pacijenta nije uspjela. Molimo pokušajte ponovo.",
        "staff-assist": "Idi na recepciju",
        "title-v2": "Kratko pitanje",
        "subtitle-v2": "Radi sigurnosti unesite svoje ime.",
        "no-match-v2": "S tim imenom vas nismo pronašli. Provjerite pravopis ili se obratite recepciji.",
        "still-ambiguous-v2": "Još vas nismo mogli jednoznačno pronaći. Obratite se recepciji.",
        "select-error-v2": "Nažalost nije uspjelo. Pokušajte ponovno."
      },
      "card-checkin": {
        "title": "Potvrdi prijavu",
        "subtitle": "Vaši podaci su uspješno pročitani.",
        "confirm": "Potvrdi prijavu"
      },
      "register-from-card": {
        "title": "Nova registracija",
        "subtitle": "Još niste u našem sustavu. Želite li se registrirati?",
        "card-data": "Podaci kartice",
        "create": "Registriraj se",
        "create-error": "Registracija nije uspjela. Pokušajte ponovno ili zatražite pomoć od osoblja.",
        "staff-assist": "Nazovite osoblje",
        "no-card-data-title": "Nema podataka o kartici",
        "no-card-data": "Nije moguće pročitati podatke s vaše kartice.",
        "insurance-verified": "Osiguranje potvrđeno: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Vaši podaci s kartice",
        "subtitle-v2": "Provjerite svoje podatke. Ako nešto nije točno, dodirnite „Promijeni”.",
        "create-v2": "Potvrdi podatke",
        "create-error-v2": "Prijava nažalost nije uspjela. Pokušajte ponovno ili se obratite recepciji.",
        "insurer-missing-v2": "Na vašoj kartici nedostaje podatak o zdravstvenom osiguranju. Obratite se recepciji.",
        "edit": "Promijeni",
        "name": "Ime",
        "insurer": "Zdravstveno osiguranje"
      },
      "patient-lookup": {
        "title": "Pretraži pacijenta",
        "subtitle": "Molimo unesite svoje ime ili broj osiguranja.",
        "lastname": "Prezime",
        "lastname-placeholder": "Vaše prezime",
        "dob": "Datum rođenja",
        "firstname": "Ime",
        "firstname-placeholder": "Vaše ime",
        "search": "Traži",
        "searching": "Pretraživanje...",
        "search-placeholder": "Ime ili broj osiguranja...",
        "results-placeholder": "Rezultati pretraživanja će se pojaviti ovdje",
        "found": "Pacijent pronađen!",
        "confirm-identity": "Molimo potvrdite da ste prikazani pacijent.",
        "confirm-button": "to sam ja",
        "ambiguous-firstname": "Pronađeno je više pacijenata. Molimo unesite svoje ime.",
        "ambiguous-additional": "Pronađeno je više pacijenata. Molimo kontaktirajte osoblje.",
        "disambiguation-hint": "To nam pomaže da vas jasno identificiramo.",
        "not-found": "Nije pronađen nijedan pacijent s ovim detaljima.",
        "error": "Pogreška pretraživanja: {{message}}",
        "staff-assist": "Pozovite osoblje",
        "not-found-prompt": "Nije pronađeno?",
        "register-new": "Registriraj novo",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Prijava bez kartice",
        "subtitle-firstname": "Unesite i svoje ime.",
        "ambiguous-firstname-v2": "Više osoba ima ovo prezime. Unesite i svoje ime.",
        "search-again": "Traži ponovno",
        "found-v2": "Pronašli smo vas",
        "found-confirm": "Potvrdite s „To sam ja”.",
        "not-found-title": "Nismo vas pronašli",
        "not-found-check": "Provjerite pravopis i datum rođenja. Recepcija će vam rado pomoći.",
        "not-found-reception": "Provjerite pravopis i datum rođenja ili se obratite recepciji.",
        "ambiguous-additional-v2": "Nismo vas mogli jednoznačno pronaći. Obratite se recepciji.",
        "error-v2": "Pretraga trenutačno nije uspjela. Pokušajte ponovno."
      },
      "checking-in": {
        "title": "Trenutak — prijavljujemo vas.",
        "subtitle": "Dodajemo vas u red čekanja za liječenje i obavještavamo tim.",
        "step-insurance": "Osiguranje provjereno",
        "step-appointment": "Termin potvrđen",
        "step-waitlist": "Dodavanje na listu čekanja",
        "error": "Prijava nije uspjela. Molimo pokušajte ponovo.",
        "continue": "Svejedno nastavi",
        "title-v2": "Trenutak, molim",
        "loading": "Prijavljujemo vas …",
        "subtitle-v2": "Upisujemo vas na listu čekanja i obavještavamo tim.",
        "error-title": "Nažalost nije uspjelo",
        "error-v2": "Vašu prijavu nije bilo moguće dovršiti.",
        "error-body": "Pokušajte ponovno. Ako opet ne uspije, pomoći će vam recepcija."
      },
      "appointment-selection": {
        "title": "Odaberite termin",
        "subtitle": "Danas imate nekoliko sastanaka. Odaberite jedan.",
        "checking-in": "Prijava...",
        "time": "{{time}}",
        "error-v2": "Prijava za ovaj termin nije uspjela. Pokušajte ponovno ili se obratite recepciji."
      },
      "no-appointment": {
        "title": "Nije pronađen termin",
        "subtitle": "Danas nismo mogli pronaći termin za vas. Molimo rezervirajte redovni termin.",
        "book-appointment": "Rezervirajte termin",
        "book-appointment-description": "Rezervirajte novi termin putem redovnog rasporeda.",
        "staff-assist": "Pozovite osoblje",
        "staff-assist-description": "Trebam pomoć.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Danas za vas nismo pronašli termin.",
        "book-v2": "Dogovorite novi termin",
        "book-v2-description": "Odaberite sada slobodan termin.",
        "have-appointment": "Imam termin",
        "have-appointment-description": "Recepcija će vam rado pomoći.",
        "unavailable-title": "Termine dogovarajte na recepciji",
        "subtitle-unavailable": "Danas za vas nismo pronašli termin. Obratite se recepciji."
      },
      "staff-assist": {
        "title": "Osoblje obaviješteno",
        "subtitle": "Član osoblja će vam uskoro pomoći.",
        "message": "Molimo pričekajte ovdje. Član osoblja će uskoro doći s vama.",
        "start-over": "Povratak na početak",
        "auto-redirect": "Povratak na početak za {{seconds}} sekundi..."
      },
      "eeb-prompt": {
        "title": "Provjeri osiguranje",
        "title-failed": "Provjera neuspješna",
        "subtitle": "Kako želite provjeriti svoje osiguranje?",
        "subtitle-failed": "Skenirajte QR kod svojom aplikacijom osiguranja za zahtjev provjere.",
        "verify-card": "Provjeri elektronički",
        "verify-card-description": "Pošaljite zahtjev svom osiguravatelju.",
        "select-insurer": "Odaberi osiguravatelja",
        "select-insurer-description": "Ručni odabir vašeg osiguravatelja.",
        "skip": "Preskoči",
        "eyebrow-chip": "alternativa",
        "eyebrow": "Prijava · dokaz o osiguranju (eEB)",
        "recommended": "Preporučeno",
        "qr-title": "Skenirajte svojom aplikacijom za osiguranje",
        "qr-description": "Otvorite aplikaciju zdravstvenog osiguranja i skenirajte kod — eEB se šalje izravno nama.",
        "qr-address-label": "Pošalji na",
        "title-app": "Potvrda putem aplikacije",
        "subtitle-app": "Vaše osiguranje nam može i izravno poslati potvrdu. Kad završite, dodirnite „Dalje”."
      },
      "quarterly-check": {
        "title": "Provjera osiguranja",
        "checking": "Provjeravamo vašu trenutnu provjeru osiguranja...",
        "error": "Provjera nije mogla biti izvršena.",
        "title-v2": "Vaše osiguranje",
        "checking-v2": "Provjeravamo vaše osiguranje – trenutak, molim.",
        "error-body": "Vaša prijava je završena. Osiguranje će s vama riješiti recepcija."
      },
      "insurer-prefilled": {
        "title": "Vaše zdravstveno osiguranje",
        "subtitle": "Molimo potvrdite svoje osiguranje za ovaj kvartal.",
        "your-insurance": "Vaše osiguranje",
        "last-read": "Zadnja provjera {{date}}",
        "quarterly-notice": "Za potrebe naplate potreban nam je trenutni dokaz osiguranja za ovaj kvartal.",
        "confirm-button": "Da, ovo je moje osiguranje",
        "change-button": "Imam drugo osiguranje",
        "contact-title": "Zatražite elektronički dokaz pokrića",
        "contact-description": "Nazovite svoje osiguranje i zatražite elektronički dokaz pokrića za:",
        "contact-patient": "strpljiva",
        "contact-kim-address": "KIM adresa ordinacije",
        "contact-phone": "Phone",
        "question": "Je li ovo vaše zdravstveno osiguranje?",
        "quarterly-notice-v2": "Jednom u tromjesečju trebamo potvrdu vašeg osiguranja."
      },
      "insurer-search": {
        "title": "Odaberite zdravstveno osiguranje",
        "subtitle": "Molimo pretražite i odaberite svoje obvezno zdravstveno osiguranje.",
        "placeholder": "Pretraži osiguranje...",
        "hint": "Unesite najmanje 2 znaka za pretraživanje.",
        "no-results": "Nema pronađenog osiguranja.",
        "no-results-hint": "Provjerite pravopis ili pokušajte drugu pretragu.",
        "label": "Naziv vašeg zdravstvenog osiguranja",
        "search-error-v2": "Pretraga trenutačno nije uspjela. Pokušajte ponovno.",
        "app-alternative": "Radije putem aplikacije osiguranja?"
      },
      "insurer-contact": {
        "title": "Zatražite dokaz o osiguranju",
        "subtitle": "Odaberite jednu od sljedećih opcija.",
        "or": "ili",
        "option-eeb-title": "Zahtjev elektroničkim putem",
        "option-eeb-description": "Ako postoji zakonski izniman slučaj, nakon vaše privole možete predati zahtjev timu ordinacije.",
        "option-qr-title": "Skeniraj pomoću aplikacije",
        "option-qr-description": "Skenirajte QR code pomoću aplikacije za osiguranje.",
        "option-call-title": "Nazovite sebe",
        "option-call-description": "Nazovite svoje osiguranje i zatražite eEB za ovu ordinaciju:",
        "phone": "Phone",
        "phone-not-available": "Broj telefona na kartici osiguranja",
        "patient-name": "strpljiva",
        "practice-kim": "KIM adresa ordinacije",
        "help-notice": "Ukoliko imate bilo kakvih problema, posjetite recepciju.",
        "submit-eeb-button": "Zatražite sada",
        "contacted-button": "Zvao sam",
        "contacted-button-countdown": "Vrijeme je za vaš poziv ({{seconds}}s)",
        "go-to-counter-button": "Idi na recepciju",
        "qr-continue-button": "Skenirao sam",
        "qr-continue-button-countdown": "Vrijeme skeniranja ({{seconds}}s)",
        "title-v2": "Potvrda vašeg zdravstvenog osiguranja",
        "subtitle-v2": "Najjednostavnije je putem aplikacije vašeg osiguranja.",
        "subtitle-no-app": "Odaberite kako nam vaše osiguranje treba poslati potvrdu.",
        "option-eeb-description-v2": "Mi ćemo za vas zatražiti potvrdu od osiguranja. Za to nam treba vaša suglasnost.",
        "call-instruction": "Nazovite svoje osiguranje i zamolite da potvrdu pošalju našoj ordinaciji.",
        "call-instruction-practice": "Nazovite svoje osiguranje i zamolite da potvrdu pošalju ordinaciji {{practice}}.",
        "done-button": "Gotovo – dalje",
        "done-button-countdown": "Gotovo – dalje (još {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Pristanak",
        "subtitle": "Potreban nam je vaš pristanak za elektroničku provjeru osiguranja.",
        "insurance": "Vaše osiguranje",
        "consent-title": "Pristanak za elektroničku provjeru osiguranja (eEB)",
        "consent-text": "Razumijem da će moje zdravstveno osiguranje prenijeti moje podatke o osiguranju (npr. ime, datum rođenja, broj osiguranja) putem sigurne komunikacijske usluge KIM ordinaciji {{practiceName}} kao dokaz o osiguranju. Pristajem na ovaj prijenos. Svjestan/svjesna sam da mogu opozvati ovaj pristanak u bilo kojem trenutku bez utjecaja na moje liječenje.",
        "withdrawal-notice": "Možete opozvati ovaj pristanak u bilo kojem trenutku.",
        "agree-button": "Slažem se",
        "decline-button": "Otkaži",
        "treatment-notice": "Vaše liječenje nije pod utjecajem ovog pristanka.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Potvrda vašeg zdravstvenog osiguranja",
        "summary": "Vaše osiguranje nam izravno šalje potvrdu. Za to nam treba vaša suglasnost.",
        "confirm-first": "Najprije potvrdite izjavu."
      },
      "qr-code": {
        "title": "Skeniraj aplikacijom osiguranja",
        "instruction-1": "Otvorite svoju aplikaciju osiguranja i skenirajte ovaj QR kod.",
        "instruction-2": "Ordinacija će zatim automatski primiti potvrdu vašeg osiguranja.",
        "practice": "Ordinacija: {{name}}",
        "alternative-hint": "Alternativa: Koristite svoju aplikaciju osiguranja",
        "instruction-app": "Otvorite aplikaciju svog zdravstvenog osiguranja i skenirajte ovaj kod. Potvrda tada stiže izravno k nama.",
        "staff-line": "Za tim ordinacije: {{address}}",
        "staff-line-practice": "Za tim ordinacije: {{name}} · {{address}}",
        "alternative-app": "Potvrdu možete zatražiti i putem aplikacije svog osiguranja: otvorite aplikaciju i skenirajte ovaj kod."
      },
      "register-basics": {
        "title": "Osobni podaci",
        "subtitle": "Molimo unesite svoje podatke.",
        "family-name": "Prezime",
        "given-name": "Ime",
        "dob": "Datum rođenja",
        "gender": "Spol",
        "insurance-type": "Vrsta osiguranja",
        "insurer-name": "Naziv vašeg osiguranja",
        "insurer-name-placeholder": "npr. Debeka, DKV, Allianz...",
        "gender-required": "Odaberite jednu mogućnost."
      },
      "register-insurer": {
        "title": "Zdravstveno osiguranje",
        "subtitle": "Molimo odaberite svoje zdravstveno osiguranje.",
        "search-placeholder": "Pretraži osiguranje..."
      },
      "register-details": {
        "title": "Sažetak",
        "subtitle": "Molimo pregledajte svoje podatke.",
        "create": "Dovrši registraciju",
        "missing-data": "Molimo ispunite sva potrebna polja.",
        "create-error": "Registracija nije uspjela. Molimo pokušajte ponovo.",
        "policy-number": "Broj police (neobavezno)",
        "policy-number-placeholder": "Vaš broj police",
        "create-v2": "Završi prijavu",
        "policy-number-hint": "Broj ćete pronaći na kartici svog osiguranja."
      },
      "diff-review": {
        "eyebrow-chip": "pregled",
        "eyebrow": "Prijava · podaci kartice",
        "title": "Usporedba podataka",
        "subtitle": "Pronađene su razlike između podataka s vaše kartice i naših zapisa.",
        "col-current": "Trenutni rekord",
        "col-new": "Novo s kartice",
        "new-badge": "novi",
        "field-fallback": "Polje",
        "note": "Ažurirani podaci pomažu nam da pravilno naplatimo i da dođemo do vas u hitnim slučajevima.",
        "comparison-placeholder": "Usporedba će biti prikazana ovdje",
        "confirm": "Potvrdi promjene",
        "apply-error": "Podaci se ne mogu primijeniti. Molimo pokušajte ponovo.",
        "retry": "Pokušajte ponovno",
        "skip": "Svejedno nastavi",
        "no-changes": "Nema pronađenih promjena",
        "title-v2": "Vaši podaci su se promijenili",
        "subtitle-v2": "Na vašoj kartici su noviji podaci. Da ih preuzmemo?",
        "confirm-v2": "Preuzmi i prijavi",
        "keep": "Prijava bez promjene",
        "col-current-v2": "Dosad",
        "col-new-v2": "Novo s kartice",
        "value-yes": "Da",
        "value-no": "Ne"
      },
      "insurance-selection": {
        "title": "Vrsta osiguranja",
        "subtitle": "Molimo odaberite svoju vrstu osiguranja.",
        "gkv": "Zakonski osiguran",
        "gkv-description": "Član obveznog zdravstvenog osiguranja.",
        "pkv": "Privatno ili samoplačanje",
        "pkv-description": "Privatno osiguran ili samoplačanje.",
        "pkv-description-v2": "Privatno zdravstveno osiguranje ili plaćate sami."
      },
      "eeb-request": {
        "title": "Zahtjev je zabilježen",
        "subtitle": "Možete dovršiti prijavu. Odgovor od {{insurer}} stići će u ordinaciju kasnije.",
        "verifying": "Vaš zahtjev je prihvaćen na neposrednu obradu.",
        "success": "Vaš zahtjev je sigurno predan timu ordinacije.",
        "error": "Potvrda zahtjeva nije dostupna.",
        "try-alternative": "Alternativna metoda",
        "kim-load-error": "KIM adresa ordinacije nije se mogla učitati.",
        "kim-label": "Ordinacija · KIM",
        "non-blocking-note": "Ovo još ne potvrđuje primitak od strane vašeg zdravstvenog osiguranja ni vaš status osiguranja.",
        "auto-continue": "Automatski nastavak za {{seconds}} sekundi.",
        "unavailable-title": "Nažalost nije uspjelo",
        "unavailable-v2": "Vaš zahtjev prema zdravstvenom osiguranju nije bilo moguće zabilježiti.",
        "unavailable-body": "Potvrdu možete zatražiti putem aplikacije osiguranja ili to riješiti na recepciji.",
        "use-app": "Putem aplikacije",
        "at-reception": "Riješiti na recepciji"
      },
      "self-pay": {
        "title": "Samoplačanje",
        "subtitle": "Bit ćete tretirani kao pacijent sa samoplačanjem.",
        "info": "Molimo imajte na umu da ćete biti odgovorni za troškove liječenja.",
        "confirm": "Razumijem",
        "title-v2": "Plaćate sami",
        "subtitle-v2": "Liječenje plaćate sami.",
        "insured-after-all": "Ipak sam osiguran"
      },
      "done": {
        "title": "Gotovo!",
        "subtitle": "Vaša prijava je završena.",
        "finish": "Završi",
        "done-label": "Gotovo",
        "error-label": "Obavijest",
        "eyebrow": "Prijava · završena",
        "queue-label": "Čekaonica",
        "queue-title": "Molim vas sjednite",
        "queue-meta": "Osobno ćemo vas nazvati.",
        "success-title": "Prijava uspješna!",
        "success-subtitle": "Molimo sjednite u čekaonicu. Bit ćete pozvani.",
        "auto-redirect": "Uskoro ćete biti preusmjereni na početnu stranicu...",
        "auto-redirect-countdown": "Povratak na početak za {{seconds}} sekundi...",
        "card-expired-title": "Kartica istekla",
        "card-expired-subtitle": "Vaša zdravstvena kartica je istekla.",
        "card-expired-info": "Molimo kontaktirajte osoblje za pomoć.",
        "back-to-start": "Natrag na početak",
        "anamnesis-title": "Kompletan obrazac povijesti bolesti",
        "anamnesis-description": "Skenirajte QR code kako biste jednostavno ispunili obrazac svoje povijesti bolesti na svom pametnom telefonu.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Prijavljeni ste",
        "card-expired-info-v2": "Obratite se recepciji."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Provjerite svoje podatke",
          "balance-prefix": "Pri spremanju:",
          "balance-direct-v2": "Odmah spremljeno: {{count}}",
          "balance-reception-v2": "Provjerava recepcija: {{count}}",
          "chip-reception-v2": "Promjene provjerava naša recepcija",
          "chip-changed": "Promijenjeno: {{count}}",
          "remove": "Ukloni",
          "example-email": "npr. ime@primjer.hr",
          "example-phone": "npr. 091 234 5678",
          "intro-v2": "Vaša prijava je završena. Jesu li ovi podaci još točni? Provjera je dobrovoljna.",
          "auto-hide": "Prikazane vrijednosti nakon kratkog vremena ponovno se skrivaju."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Ovaj podatak proslijedili smo recepciji.",
          "banner-done-v2": "Hvala! Primili smo vaše podatke.",
          "footer-v2": "Svi ostali podaci ostaju nepromijenjeni."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Iz razloga zaštite podataka zatvorili smo prikaz. Vaša prijava je ipak završena. Promjene možete u bilo kojem trenutku javiti recepciji."
        }
      },
      "progress": {
        "identify": "Prijava",
        "insurance": "Osiguranje",
        "done": "Gotovo"
      },
      "dob-format-hint": "Na primjer 01.10.1980",
      "dob-required": "Unesite svoj datum rođenja.",
      "insurance-label": {
        "GKV": "Obvezno osiguranje",
        "PKV": "Privatno osiguranje",
        "SELFPAY": "Samoplatitelj"
      }
    },
    "emergency": {
      "title": "Akutna Hitna!",
      "label": "Hitna pomoć",
      "subtitle": "Ovaj se alarm čuje samo lokalno i nije pozvao pomoć. U akutnim ili potencijalno životno ugrožavajućim slučajevima nazovite 112.",
      "call-emergency": "Nazovi hitnu službu (112)",
      "stop-sound": "Zaustavi zvuk",
      "play-sound": "Reproduciraj zvuk",
      "back-to-start": "Povratak na početak",
      "headline": "Odmah se obratite osoblju na recepciji. U slučaju opasnosti po život nazovite 112."
    },
    "help-reception": "Pomoć na recepciji",
    "help-reception-toast": "Molimo kontaktirajte recepciju. Rado ćemo pomoći.",
    "language-entry": {
      "title": "Odaberite jezik"
    },
    "loading": "Učitavanje…",
    "step-progress-label": "Napredak",
    "step-progress-phase": "Odjeljak {{current}} od {{total}}: {{phase}}",
    "step-progress-substep": "Dio {{current}} od {{total}}",
    "step-progress-complete": "Završeno",
    "identification": {
      "title": "Tko ste vi?",
      "lead": "Najbrže ide sa zdravstvenom iskaznicom. Možete i pretraživati po imenu.",
      "lead-card-only": "Molimo umetnite zdravstvenu iskaznicu u čitač kartica.",
      "mode-label": "Kako se želite prijaviti?",
      "mode-card": "Karticom",
      "mode-search": "Traži po imenu",
      "mode-create": "Novi pacijent",
      "card": {
        "loading": "Priprema čitača kartica …",
        "checking": "Provjera čitača kartica …",
        "insert-title": "Molimo umetnite zdravstvenu iskaznicu u čitač kartica.",
        "insert-detail": "Vaše podatke čitamo automatski.",
        "detected": "Kartica prepoznata",
        "read": "Pročitaj karticu",
        "reading": "Kartica se čita …",
        "reading-hint": "Molimo ostavite karticu u čitaču.",
        "no-terminal-title": "Čitač kartica nije dostupan",
        "help-with-search": "Molimo pretražite po imenu ili pitajte na recepciji.",
        "help-reception": "Molimo pitajte na recepciji – rado ćemo pomoći.",
        "unreadable-title": "Kartica prepoznata, ali nije čitljiva",
        "error-title": "Karticu nije bilo moguće pročitati",
        "not-unique": "Niste jednoznačno povezani s ovom karticom. Molimo pretražite po imenu ili pitajte na recepciji.",
        "no-match": "Za ovu karticu nismo pronašli podatke. Molimo pretražite po imenu ili pitajte na recepciji.",
        "without-card": "Nastavi bez kartice"
      },
      "lookup": {
        "lead": "Molimo unesite prezime i datum rođenja.",
        "first-name": "Ime",
        "last-name": "Prezime",
        "dob": "Datum rođenja",
        "dob-hint": "Format: DD.MM.GGGG",
        "search": "Traži",
        "confirm": "Da, to sam ja",
        "found-title": "Pronašli smo vas",
        "found-body": "Molimo potvrdite da se radi o vama.",
        "first-name-needed-title": "Molimo dodajte svoje ime",
        "first-name-needed-body": "Kako bismo vas jednoznačno pronašli. Zatim dodirnite „Traži”.",
        "ambiguous-title": "Nismo vas mogli jednoznačno pronaći",
        "ambiguous-body": "Molimo pitajte na recepciji – rado ćemo pomoći.",
        "not-found-title": "Nema odgovarajućih podataka",
        "not-found-body": "Molimo provjerite unesene podatke.",
        "error-title": "Pretraživanje trenutačno nije moguće",
        "error-body": "Molimo pokušajte ponovno ili pitajte na recepciji."
      },
      "create": {
        "insurance-question": "Kako ste osigurani?",
        "insurance-required": "Molimo odaberite kako ste osigurani.",
        "error-title": "Vaše podatke nije bilo moguće spremiti",
        "error-body": "Molimo pokušajte ponovno ili pitajte na recepciji."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Prvo otključaj",
      "subtitle": "FrontDesk+ mora biti aktiviran u vašem softveru za vježbanje.",
      "step1": "Naručite u SolStore (ili vaš Doc-Cirrus partner naručuje umjesto vas).",
      "step2": "Nakon aktivacije, aktivirajte u inSuite pod “inSuite Sols” (administratorska prava).",
      "step3": "Otvorite Bridge administraciju → “Dodaj uređaj”.",
      "cta": "Sve gotovo - idemo dalje"
    },
    "welcome": {
      "title": "Dodajte ovaj uređaj ordinaciji",
      "scan": "Fotografirajte šifru",
      "prepare-link": "Nema koda u inSuite?",
      "language": "Jezik"
    },
    "scan": {
      "requesting": "Zatražen je pristup kameri…",
      "scanning": "Usmjerite kameru prema kodu",
      "paste": "Umjesto toga zalijepite",
      "manual-title": "Povežite se ručno",
      "manual-description": "Ako QR kod nije dostupan, uzmite podatke o vezi od administracije Bridge.",
      "address-label": "Bridge adresa",
      "address-placeholder": "https://…/_ostatak_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Umetnite SOLTOKEN",
      "manual-submit": "Preuzmi vezu",
      "error-title": "Kod nije prepoznat",
      "camera-denied-title": "Pristup kameri odbijen",
      "camera-denied-hint": "Dopustite pristup kameri u postavkama i pokušajte ponovno.",
      "retry": "Pokušajte ponovno"
    },
    "preflight": {
      "title": "Bit će postavljeno",
      "all-green": "Svi testovi su prošli",
      "practice": "Praksa",
      "device-name": "Naziv uređaja",
      "device-name-placeholder": "npr. B. Prijem 1",
      "card-reader": "Čitač kartica",
      "pin": "Novi tajni broj",
      "pin-placeholder": "Četveroznamenkasti PIN",
      "finish": "Završiti",
      "recheck": "Provjerite ponovno",
      "diagnosis": "ID dijagnoze",
      "checklist-error": "Bridge je odbio vezu ili nije dostupan. Provjerite SOLTOKEN i adresu Bridgea.",
      "checklist-retry": "Provjeri ponovno",
      "edit-token": "Promijeni SOLTOKEN",
      "rescan": "Ponovno skeniraj kod"
    },
    "persisting": "Spremanje postavki …",
    "success": {
      "title": "Dodan uređaj",
      "detail": "Uređaj se upravo pojavio na računalu za vježbanje.",
      "starting": "Počinje režim pacijenta..."
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Povezivanje sa softverom za vježbanje",
        "fix": "Bridge Provjerite vezu i adresu poslužitelja."
      },
      "missing_insuite_url": {
        "label": "inSuite adresa",
        "fix": "Ponovno skenirajte QR kod - adresa nedostaje."
      },
      "missing_server_token": {
        "label": "Token poslužitelja",
        "fix": "Ponovno skenirajte QR kod - token nedostaje."
      },
      "missing_gateway_session": {
        "label": "Gateway sesija",
        "fix": "Prijavite se ponovo — sesija nedostaje."
      },
      "missing_gateway_enrollment": {
        "label": "Registracija uređaja",
        "fix": "Registrirajte uređaj na Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway spremnost",
        "fix": "Pričekajte da Gateway završi postavljanje."
      },
      "token_verification_failed": {
        "label": "Provjera žetona",
        "fix": "Provjerite token poslužitelja ili Bridge vezu."
      },
      "session_expired": {
        "label": "sastanak",
        "fix": "Sesija je istekla - prijavite se ponovo."
      },
      "device_revoked": {
        "label": "Status uređaja",
        "fix": "Ovaj uređaj je blokiran. Kontaktirajte ordinaciju."
      },
      "missing_practice_name": {
        "label": "Naziv prakse",
        "fix": "Naziv medicinske prakse nije moguće učitati (inSuite)."
      },
      "missing_device_name": {
        "label": "Naziv uređaja",
        "fix": "Unesite naziv uređaja."
      },
      "telematik_unavailable": {
        "label": "Telematička infrastruktura",
        "fix": "Izborno — provjera kartice ostaje moguća čim TI postane dostupan."
      },
      "selected_card_reader_unavailable": {
        "label": "Čitač kartica",
        "fix": "Izborno — odaberite ili povežite čitač kartica."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Neobavezno — umetnite iskaznicu medicinske prakse (SMC-B)."
      }
    },
    "token": {
      "title": "Unesite SOLTOKEN",
      "description": "Iz sigurnosnih razloga QR kod ne sadrži SOLTOKEN. Kopirajte ga u inSuiteu pod „Sol-Aktivierung” (FrontDesk+) i zalijepite ovdje.",
      "submit": "Nastavi",
      "rescan": "Ponovno skeniraj kod"
    }
  }
}
